export const BASE_ITEM_COLOR = [
    "rgba(20,156,206,0.2)",
    "#C7DAF0",
    "#C2CBF8",
    "#E4D4F8",
    "#FACEF3",
    "#FADBE1",
    "#FCF8D6",
    "#D7F6D4",
    "#EAEAEA",
    "#AFAFAF",
];

